import { handleActions } from 'redux-actions';

import * as AC from './actions';

const initialState = {
  isBottom: false,
};

export default handleActions(
  {
    [AC.SET_IS_BOTTOM]: (store, { payload }) => ({
      ...store, isBottom: payload,
    }),
  },
  initialState,
);
